import GenericDialog from "./generic";
import { updateSite } from "api/site";
import { Site, SiteUpdateBody } from "api/types/site";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLoading } from "store/appSlice";
import SiteConfigurationForm, {
  SiteConfigurationFormType,
} from "widgets/forms/sites/configuration";
import { Alert } from "api/types/alerts";

const SiteConfigurationDialog = (props: {
  site?: Site | Alert;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  context?: "site" | "escalation";
  readonly?: boolean;
}) => {
  const {
    site,
    isOpen,
    onClose,
    onSuccess,
    context = "site",
    readonly = false,
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const doUpdateSite = async (formData: SiteConfigurationFormType) => {
    const body: SiteUpdateBody = {
      id: (site as Site)?.id,
      rateStructureId: formData.rateStructureId,
      collector: formData.collector,
      billingPeriod: formData.billingPeriod,
      serviceLevel: formData.serviceLevel,
      escalationConfig: formData.escalationConfig,
    };

    dispatch(setLoading(true));
    const { status, isLoading } = await updateSite(body);
    dispatch(setLoading(isLoading));

    if (status && status === 200) {
      onSuccess();
    }
  };

  return (
    <GenericDialog
      isOpen={isOpen}
      title={t("dialog.site.configuration.title", { context })}
      onExit={onClose}
      size="lg"
    >
      <SiteConfigurationForm
        context={context}
        values={{
          rateStructureId: (site as Site)?.rateStructureId || "",
          collector: (site as Site)?.collector || "",
          billingPeriod: (site as Site)?.billingPeriod || "",
          serviceLevel: (site as Site)?.serviceLevel || "",
          escalationConfig:
            context === "escalation" && (site as Alert)?.config
              ? {
                  enabled: (site as Alert).config.enabled || false,
                  levels: (site as Alert).config.levels || [],
                  patriotLevel: (site as Alert).config.patriotLevel || 0,
                }
              : !(site as Site)?.escalationConfig ||
                !Array.isArray((site as Site)?.escalationConfig.levels) ||
                (site as Site)?.escalationConfig.levels.length === 0
              ? {
                  enabled: false,
                  levels: [],
                  patriotLevel: 0,
                }
              : (site as Site).escalationConfig,
        }}
        submit={doUpdateSite}
        onClose={onClose}
        readonly={readonly}
      />
    </GenericDialog>
  );
};

export default SiteConfigurationDialog;
